import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    brandId: { type: Number, default: 0 },
    campaignId: { type: Number, default: 0 }
  }

  connect() {
    this.releaseOnUnload = this.releaseOnUnload?.bind(this) || this.releaseOnUnload
    window.addEventListener('beforeunload', this.releaseOnUnload)
    document.addEventListener('turbo:before-visit', this.releaseOnUnload)
  }

  releaseOnUnload(event) {
    try {
      if (!this.brandIdValue || !this.campaignIdValue) return

      if (event.type === 'turbo:before-visit') {
        const nextUrl = event.detail?.url
        if (nextUrl) {
          const currentCampaignPath = `/brands/${this.brandIdValue}/campaigns/${this.campaignIdValue}`
          if (nextUrl.includes(currentCampaignPath)) {
            return
          }
        }
      }

      const url = `/brands/${this.brandIdValue}/campaigns/${this.campaignIdValue}/release_lock`
      if (navigator.sendBeacon) {
        const blob = new Blob([], { type: 'application/json' })
        navigator.sendBeacon(url, blob)
      }
    } catch (_) {}
  }

  disconnect() {
    window.removeEventListener('beforeunload', this.releaseOnUnload)
    document.removeEventListener('turbo:before-visit', this.releaseOnUnload)
  }
}
